import React from "react";
import CareersPage from "../../components/careers";

const CareersAll = () => {
  return <CareersPage />;
};

export default CareersAll;
